import React from "react";

export const tierOf = (s) => (s == null ? "none" : s >= 75 ? "hot" : s >= 55 ? "warm" : "cold");
export const tierLabel = { hot: "Strong bolt-on", warm: "Possible fit", cold: "Weak fit", none: "Not scored" };

// Circular score ring 0–100 with tier colour; title shows the rationale.
export const ScoreBadge = ({ score, rationale, size = 40, testid, pending }) => {
  const tier = tierOf(score);
  const pct = score == null ? (pending ? 30 : 0) : Math.max(0, Math.min(100, score));
  const r = (size - 6) / 2, c = 2 * Math.PI * r;
  return (
    <div className={`om-score ${tier} ${pending ? "pending" : ""}`} style={{ width: size, height: size }} title={pending ? "Scoring…" : rationale || tierLabel[tier]} data-testid={testid}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={size / 2} cy={size / 2} r={r} className="om-ring-bg" />
        <circle cx={size / 2} cy={size / 2} r={r} className="om-ring" strokeDasharray={`${(pct / 100) * c} ${c}`} transform={`rotate(-90 ${size / 2} ${size / 2})`} />
      </svg>
      <span>{score == null ? (pending ? "" : "–") : score}</span>
    </div>
  );
};

const PARTS = [["niche", "Niche"], ["geo", "Geography"], ["size", "Size"], ["overlap", "Service overlap"], ["owner", "Owner signals"]];

export const ScoreParts = ({ parts = {}, distanceMiles }) => (
  <div className="om-parts" data-testid="om-score-parts">
    {PARTS.map(([k, label]) => (
      <div key={k} className="om-part">
        <span>{label}{k === "geo" && distanceMiles != null ? ` · ~${distanceMiles} mi` : ""}</span>
        <div className="om-bar"><div style={{ width: `${((parts[k] || 0) / 20) * 100}%` }} /></div>
        <b>{parts[k] ?? 0}/20</b>
      </div>
    ))}
  </div>
);
